export default {"src":"/_next/static/media/RIG.5a5ef219.svg","height":18,"width":18};